import styles from "./styles.module.css";

export const Spinner = () => <div className={styles.loader}></div>;
